<template>
  <div class="app-layout">
    <nav-bar />
    <div class="main-container">
      <side-bar :menu-items="menuItems" />
      <main-content />
    </div>
  </div>
</template>

<script>
import NavBar from "./commons/Navbar.vue";
import SideBar from "./commons/Sidebar.vue";
import MainContent from "./commons/mainContent.vue";
import { auth } from "@/api/auth.js";
import store from "@/store";
export default {
  components: {
    NavBar,
    SideBar,
    MainContent,
  },
  name: "LayoutBase",
  computed: {
    menuItems() {
      const routes = this.$router.options.routes;
      const filteredRoutes = routes.filter((route) => {
        // 过滤掉登录页等不需要在菜单显示的路由
        return route.path !== "/login" && route.meta && route.meta.title;
      });

      return filteredRoutes.map((route) => ({
        path: route.path,
        title: route.meta.title,
        icon: route.meta.icon,
      }));
    },
  },
  data() {
    return {};
  },
  created() {
    // 可以在这里添加任何需要在组件创建时执行的逻辑
    // 根据url传来的vrs，调用接口/ajax/api/auth
    //1：首先检查localStorage
    const vrs = this.$route.query.vrs;
    // console.log(vrs, store.state.vrs, "");
    if (vrs == undefined || vrs === store.state.vrs) {
      //如果url传来的参数不含vrs，则检查
      return false;
    } else {
      this.getAuth(vrs);
    }
  },
  methods: {
    getAuth(vrs) {
      const params = {
        vrs: vrs,
      };
      auth(params)
        .then((response) => {
          // 存储response返回的token和用户信息
          const token = response.token;
          const user = response.user;
          // console.log("获取到的token:", token);
          // console.log("获取到的user:", user);

          this.$store.dispatch("setToken", token);
          this.$store.dispatch("setUser", user);
          this.$store.dispatch("setVrs", vrs);
          // console.log("store中的token:", this.$store.state.token);
          if (token) {
            this.$router.push({ path: "/deviceLogin", query: {} });
          }
        })
        .catch((error) => {
          // 处理认证失败的逻辑
          console.error("Auth error:", error);
        });
    },
  },
};
</script>

<style scoped>
.app-layout {
  display: flex;
  flex-direction: column;
  height: 100vh;
}

.main-container {
  display: flex;
  flex: 1;
  overflow: hidden;
}
</style>
